<template>
  <div class="embed-container" >
    <div class="iframe-bug-fix"></div>
    <iframe
      overflow-scroll=“true”
      :data-src="videoSrc"
      frameborder="0"
      webkitAllowFullScreen
      mozallowfullscreen
      allowFullScreen
      class="c-lazy-iframe"
    >
    </iframe>
  </div>
</template>

<script>
import 'intersection-observer';
import lozad from 'lozad';

export default {
  data() {
    return {
      loading: true,
    };
  },
  props: {
    videoSrc: String,
  },
  mounted() {
    const setLoadingState = () => {
      this.loading = false;
    };
    this.$el.addEventListener('load', setLoadingState);
    this.$once('hook:destroyed', () => {
      this.$el.removeEventListener('load', setLoadingState);
    });
    const observer = lozad('.c-lazy-iframe', {
      rootMargin: '10px 0px',
      threshold: 0.1,
    });
    observer.observe();
  },
};
</script>